// extracted by mini-css-extract-plugin
export default {"info":"DigitalOrderForm_info__fo3ny","orderItemsHeader":"DigitalOrderForm_orderItemsHeader__1j4s5","container":"DigitalOrderForm_container__cMjQQ"};